var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mapbox-map-root h-full relative"},[_c('div',{ref:"mapContainer",staticClass:"h-full"}),_vm._t("overlay"),_c('div',{staticClass:"hidden"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }